import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink, type LinkProps as MuiLinkProps } from '@mui/material';

interface LinkProps extends MuiLinkProps {
  to: string;
}

const Link: React.FC<LinkProps> = ({ to, underline = 'hover', sx, children, ...rest }: LinkProps) => {
  return (
    <MuiLink component={RouterLink} to={to} underline={underline} sx={sx} {...rest}>
      {children}
    </MuiLink>
  );
};

export default Link;
